// extracted by mini-css-extract-plugin
export default {"panel":"wYortV7vYd2l30fMiDJm","panelBody":"nN_qapMVbJrIAsqKRNYB","title":"FTpGS2wd_29rdWhjJlx6"};